import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { Actions, Getters, Mutations, ModalEditProfileState } from '@/interfaces/store/modalEditProfile'
import { RootState } from '@/interfaces/store/root'

export const state: ModalEditProfileState = {
  isLoadingSpinner: false,
  isModalActive: false,
  isModalClose: false
}

export const getters: GetterTree<ModalEditProfileState, RootState> & Getters = {}
export const actions: ActionTree<ModalEditProfileState, RootState> & Actions = {
  onOpen({ commit }) {
    commit('updateModalClose', false)
    commit('updateModalActive', true)
  },
  onClose({ commit }) {
    commit('updateModalClose', true)
    setTimeout(() => {
      commit('updateModalActive', false)
    }, 500)
  },
}

export const mutations: MutationTree<ModalEditProfileState> & Mutations = {
  updateIsLoadingSpinner(state: ModalEditProfileState, isLoadingSpinner: boolean) {
    state.isLoadingSpinner = isLoadingSpinner
  },
  updateModalActive(state: ModalEditProfileState, isModalActive: boolean) {
    state.isModalActive = isModalActive
  },
  updateModalClose(state: ModalEditProfileState, isModalClose: boolean) {
    state.isModalClose = isModalClose
  },
}

export const store: Module<ModalEditProfileState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
